import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subject } from 'rxjs';

interface VersionInfo {
  version: string;
  hash: string;
}

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  private currentVersion: string | null = null;
  private checkInterval = 5 * 60 * 1000; // Check every 5 minutes
  public updateAvailable$ = new Subject<boolean>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  public startVersionCheck(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // Initial check - store the current version
    this.fetchVersion();

    // Check periodically using native fetch (bypasses Angular HttpClient interceptors)
    setInterval(() => {
      this.fetchVersion();
    }, this.checkInterval);
  }

  private fetchVersion(): void {
    // Use native fetch to bypass the auth interceptor, which prepends the API URL
    fetch('/version.json?t=' + Date.now())
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch version.json');
        }
        return response.json();
      })
      .then((versionInfo: VersionInfo) => {
        if (versionInfo && versionInfo.version) {
          if (!this.currentVersion) {
            this.currentVersion = versionInfo.version;
            console.log('Initial app version:', this.currentVersion);
          } else {
            this.handleVersionCheck(versionInfo.version);
          }
        }
      })
      .catch((error) => {
        console.warn('Failed to check version:', error);
      });
  }

  private handleVersionCheck(newVersion: string): void {
    if (this.currentVersion && newVersion !== this.currentVersion) {
      console.log('New version detected:', newVersion, 'Current:', this.currentVersion);
      this.updateAvailable$.next(true);
      this.currentVersion = newVersion;
    }
  }

  public reloadPage(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.location.reload();
    }
  }
}
